import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import SharedDocuments from '../../../components/Share/SharedDocuments';

const mapStateToProps = (state: StoreState) => {
	const { sharePanel } = state;
	const { selection } = sharePanel;
	return { selection };
};

export default connect(mapStateToProps)(SharedDocuments);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/SharedDocuments/index.tsx